import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CreateTogoRequest, Party, UpdateTogoRequest } from '@shared/party/models';
import { IParams } from '@tablesready/common-ui';
import { ApiClientService } from '@tablesready/api-client';

@Injectable({providedIn: 'root'})
export class TogoPartyService {
  private readonly basePath = '/v.1/togo';

  constructor(private readonly http: ApiClientService) { }

  getToGo(params: IParams): Observable<Party[]> {
    return this.http.get<Party[]>(this.basePath, {
      params: JSON.parse(JSON.stringify(params)), // Skip undefined values
    });
  }

  createToGo(data: CreateTogoRequest): Observable<Party> {
    return this.http.post<Party>(this.basePath, data);
  }

  updateToGo(id: string, data: UpdateTogoRequest): Observable<Party> {
    return this.http.put<Party>(`${this.basePath}/${id}`, data);
  }
}
